export default __webpack_public_path__ + "static/media/complementary--turn-left--g1.6d813807.png";